// extracted by mini-css-extract-plugin
export default {"background":"BalanceModal_background__m7Cnm"};